import styled from "styled-components";

import { FONTS, SPACING } from "../../../../../utils/constants";

export const Separator = styled.span`
  color: var(--color-text-muted);
  font-size: var(--text-md);
  font-weight: 700;
  line-height: 1;
`;

export const Figure = styled.span<{ $negative: boolean }>`
  display: inline-flex;
  align-items: baseline;
  gap: ${SPACING.xs}px;
  font-family: ${FONTS.serif};
  font-size: var(--text-md);
  font-weight: 700;
  color: ${({ $negative }) =>
    $negative ? "var(--color-error)" : "var(--color-success)"};
`;

export const Tag = styled.span`
  color: var(--color-text-secondary);
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;
